import gql from 'graphql-tag';

const CREATE_MODEL = gql`
  mutation CreateModel($data: CreateModelInput!) {
    createModel(data: $data) {
      id
      name
      type
      brand {
        id
        name
      }
    }
  }
`;

const DELETE_MODEL_BY_ID = gql`
  mutation DeleteModelById($id: ID!) {
    deleteModelById(id: $id) {
      id
      name
      type
    }
  }
`;

const UPDATE_MODEL_BY_ID = gql`
  mutation UpdateModelById($id: ID!, $data: UpdateModelInput) {
    updateModelById(id: $id, data: $data) {
      id
      name
      type
      brand {
        id
        name
      }
      custom {
        id
        name
        type
        brandId
      }
    }
  }
`;

export default {
  CREATE_MODEL,
  DELETE_MODEL_BY_ID,
  UPDATE_MODEL_BY_ID,
};
